export class HomeModuleSortOrder {
  public smart_shopper: number;
  public messaging: number;
  public telehealth: number;
  public hsa_benefits: number;
  public ancillary_links: number;
  public login: number;
  public helpful_links: number;
  public rts_welcome_banner: number;
  public convenient_care: number;
  public promotional_procedures: number;
  public contact_us: number;

  constructor(sortOrder: string[]) {
    if (sortOrder?.length > 0) {
      sortOrder.forEach((value, index) => (this[value] = index));
    }
  }
}
